import { render } from "./GearMenu.vue?vue&type=template&id=37a5740f&ts=true"
import script from "./GearMenu.vue?vue&type=script&lang=ts"
export * from "./GearMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__